export default "__VITE_ASSET__B13AUm5c__"